<risr-async [wrapper]="formWrapper">
    @let letForm = formWrapper.value();
    @if (letForm) {
        <risr-form-renderer [risrForm]="letForm"></risr-form-renderer>
    }
</risr-async>
@let reportForm = $reportForm();
@if (reportForm) {
    <h2 i18n>Report form</h2>
    <risr-form-renderer [risrForm]="reportForm"></risr-form-renderer>
}